"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Button = _styledComponents.default.button.withConfig({
  displayName: "DownloadButton__Button",
  componentId: "design-system__sc-9uy3sj-0"
})(["padding:0;border:1px solid ", ";background-color:white;display:flex;align-items:center;border-radius:", ";cursor:pointer;span{display:block;padding:12px 8px;border-right:1px solid ", ";font-size:", ";font-family:", ";color:", ";line-height:100%;font-weight:bold;}svg{width:22px;height:22px;margin:0 8px;path{fill:", ";}}"], _BaseTheme.default.colors.blue, _BaseTheme.default.radius.regular, _BaseTheme.default.colors.blue, _BaseTheme.default.type.size.normal, _BaseTheme.default.type.family.system, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.blue);

const DownloadButton = _ref => {
  let {
    children,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Button, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", null, children), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "download"
  }));
};

DownloadButton.propTypes = {
  children: _propTypes.default.string,
  onClick: _propTypes.default.func
};
DownloadButton.defaultProps = {
  children: '',
  onClick: () => {}
};
var _default = DownloadButton;
exports.default = _default;